import { createSelectorCreator, defaultMemoize } from 'reselect';
import isEqual from 'lodash.isequal';
import moment from 'moment';

// Selectors
import {
    makeSelectQueryStringValue,
    makeSelectQueryStringNumberValue
} from '../../workspaces/react-router-selectors';

const createDeepEqualSelector = createSelectorCreator(defaultMemoize, isEqual);

interface Props {
    numberOfDays: number;
}

const selectNumberOfDaysProp = (state: *, props: Props) =>
    props && props.numberOfDays;

const selectNumberOfDays = createDeepEqualSelector(
    [selectNumberOfDaysProp, makeSelectQueryStringNumberValue('numberOfDays')],
    (numberOfDaysProp, queryStringNumberOfDaysState) =>
        numberOfDaysProp || queryStringNumberOfDaysState || 7
);

const selectFirstDate = createDeepEqualSelector(
    [makeSelectQueryStringValue('date'), selectNumberOfDays],
    (dateState, numberOfDaysState) => {
        const momentDate = dateState
            ? moment(dateState, 'YYYY-MM-DD')
            : moment();
        if (numberOfDaysState % 7) {
            return momentDate.format('YYYY-MM-DD');
        }

        return momentDate.startOf('isoWeek').format('YYYY-MM-DD');
    }
);

const selectLastDate = createDeepEqualSelector(
    [selectFirstDate, selectNumberOfDays],
    (firstState, numberOfDaysState) =>
        moment(firstState, 'YYYY-MM-DD')
            .add(numberOfDaysState - 1, 'day')
            .format('YYYY-MM-DD')
);

const selectPreviousDate = createDeepEqualSelector(
    [selectFirstDate, selectNumberOfDays],
    (firstState, numberOfDaysState) =>
        moment(firstState, 'YYYY-MM-DD')
            .subtract(numberOfDaysState, 'day')
            .format('YYYY-MM-DD')
);

const selectNextDate = createDeepEqualSelector(
    [selectFirstDate, selectNumberOfDays],
    (firstState, numberOfDaysState) =>
        moment(firstState, 'YYYY-MM-DD')
            .add(numberOfDaysState, 'day')
            .format('YYYY-MM-DD')
);

export { selectFirstDate, selectLastDate, selectPreviousDate, selectNextDate, selectNumberOfDays };
